<div class="container">
    <div class="row">
        <div class="col-xs-12">
            <form #cancelForm="ngForm" novalidate>
                <div class="row">
                    <div class="col-xs-12 job-match-status-statement">
                            <span>
                                '<span class="emerald">Cancel</span>' <span>{{ itemDisplayLabel }}</span> for '<span class="emerald">{{ jobMatchObject.name }}</span>'
                                for role of '<span class="emerald">{{ jobMatchObject.jobMatchTitle }}</span>' 
                                <span *ngIf="jobMatchObject.jobMatchClientName != null"> at '<span class="emerald">{{ jobMatchObject.jobMatchClientName }}</span>'
                              </span>
                            </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <div class="form-group">
                            <label style="padding-right: 10px">
                                {{ usersListLabel }} :
                            </label>
                            <div class="row">
                                <div class="col-xs-12" *ngFor="let meeting of meetingsList">
                                    <div class="radio" style="display: inline;">
                                        <input type="radio" name="chosenMeeting" [attr.id]="'chosenMeeting-' + meeting.id" [value] ="meeting"
                                               [ngModel]="chosenMeeting" (ngModelChange)="chosenMeeting = $event; meetingChanged()" [attr.disabled]="meeting.editableFlag ? null : ''">
                                        <label [attr.for]="'chosenMeeting-' + meeting.id">
                                            <span [ngClass]="{'disabled-meeting-label': !meeting.editableFlag}">
                                                <span [title]="meeting.userNamesLabel">
                                                    <span>{{ meeting.userNamesLabel | slice:0:70 }}</span>
                                                    <span *ngIf="meeting.userNamesLabel?.length > 70">..</span>
                                                </span>
                                                <span> - </span>
                                                <span>{{ meeting.scheduledTime }}</span>
                                            </span>
                                            <span [class]="meeting.statusClass + ' ml-1'" [tooltip]="meeting.statusLabel" container="body" [adaptivePosition]="false"></span>
                                            <a [class]="meeting.meetingModeClass + ' ml-2'" [href]="meeting.meetingUrl" tooltip="Start Meeting" container="body" [adaptivePosition]="false" target="_blank"></a>
                                            <span class="text-danger" *ngIf="meeting.isCreatedByClient"> (Created by Client)</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="!cancellableMeetingsExistFlag && !loadingFlag">
                    <div class="col-xs-12 text-center" style="padding-bottom: 10px">
                        <h4> {{noCancellableMeetingsLabel}}
                        </h4>
                    </div>
                </div>
                <div class="row" *ngIf="loadingFlag">
                    <div class="col-xs-12">
                            <div class="skeleton-heading skeleton-loading" style="width: 35%; margin-bottom: 14px;"></div>
                            <div *ngFor="let row of [0, 1, 2]" style="margin-bottom: 16px;">
                                <div class="skeleton-paragraph skeleton-loading" style="width: 20%; margin-bottom: 8px;"></div>
                                <div class="skeleton-loading" style="height: 34px; width: 100%;"></div>
                            </div>
                        </div>
                </div>

                <div class="row" *ngIf="showFormFlag">
                    <div class="col-xs-6">
                        <div class="form-group">
                            <label for="email" class="control-label">
                                Email :
                            </label>
                            <input type="email" name="email" id="email" class="form-control" placeholder="Email" [(ngModel)]="scheduleData.emailAddress" [disabled]="true">
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="showFormFlag">
                    <div class="col-xs-6">
                        <div class="form-group">
                            <label for="firstName" class="control-label">
                                First Name :
                            </label>
                            <input type="text" name="firstName" id="firstName" class="form-control" placeholder="First Name" [(ngModel)]="scheduleData.firstName" [disabled]="true">
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="form-group">
                            <label for="lastName" class="control-label">
                                Last Name :
                            </label>
                            <input type="text" name="lastName" id="lastName" class="form-control" placeholder="Last Name" [(ngModel)]="scheduleData.lastName" [disabled]="true">
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="showFormFlag">
                    <div class="col-xs-6">
                        <div class="form-group">
                            <label for="role" class="control-label">
                                Role :
                            </label>
                            <input type="text" name="role" id="role" class="form-control" placeholder="Role" [(ngModel)]="scheduleData.role" [disabled]="true">
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="form-group">
                            <label for="department" class="control-label">
                                Department :
                            </label>
                            <input type="text" name="department" id="department" class="form-control" placeholder="Department" [(ngModel)]="scheduleData.department" [disabled]="true">
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="showFormFlag">
                    <div class="col-xs-6">
                        <div class="row">
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label for="jobMatchScheduleStartDate" class="control-label">
                                        Start Date :
                                    </label>
                                    <div class="input-group">
                                        <div class="input-group-addon">
                                            <div class="input-group-text">
                                                <i class="fa fa-calendar"></i>
                                            </div>
                                        </div>
                                        <input type="text" name="jobMatchScheduleStartDate" id="jobMatchScheduleStartDate" class="form-control" [(ngModel)]="startDate" [disabled]="true">
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label for="jobMatchScheduleStartTime" class="control-label">
                                        Start Time :
                                    </label>
                                    <div class="input-group">
                                        <div class="input-group-addon">
                                            <div class="input-group-text">
                                                <i class="far fa-clock"></i>
                                            </div>
                                        </div>
                                        <input type="text" name="jobMatchScheduleStartTime" id="jobMatchScheduleStartTime" class="form-control" [(ngModel)]="startTime" [disabled]="true">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="row">
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label for="jobMatchScheduleEndDate" class="control-label">
                                        End Date :
                                    </label>
                                    <div class="input-group">
                                        <div class="input-group-addon">
                                            <div class="input-group-text">
                                                <i class="fa fa-calendar"></i>
                                            </div>
                                        </div>
                                        <input type="text" name="jobMatchScheduleEndDate" id="jobMatchScheduleEndDate" class="form-control" [(ngModel)]="endDate" [disabled]="true">
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-6">
                                <div class="form-group">
                                    <label for="jobMatchScheduleEndTime" class="control-label">
                                        End Time :
                                    </label>
                                    <div class="input-group">
                                        <div class="input-group-addon">
                                            <div class="input-group-text">
                                                <i class="far fa-clock"></i>
                                            </div>
                                        </div>
                                        <input type="text" name="jobMatchScheduleEndTime" id="jobMatchScheduleEndTime" class="form-control" [(ngModel)]="endTime" [disabled]="true">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="showFormFlag">
                    <div class="col-xs-12">
                        <div class="form-group" [ngClass]="{'has-error': (cancelForm.submitted && cancelForm.controls?.note?.invalid)}">
                            <label for="note" class="control-label">
                                Internal Notes<em>*</em> :
                            </label>
                            <!-- Voice Input -->
                            <div class="mb-2">
                                <app-voice-input
                                    (transcriptReady)="onVoiceTranscript($event)"
                                    [sourceScreen]="sourceScreen"
                                    [candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
                                    [company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
                                    [requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
                                    [jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null">
                                </app-voice-input>
                            </div>
                            <textarea id="note" name="note" class="form-control" rows="3"
                                placeholder="Enter your note.." [(ngModel)]="scheduleData.note"
                                (ngModelChange)="onInternalNoteChanged()"
                                required></textarea>
                            <!-- Formalize Text -->
                            <app-formalize-comment
                                [inputText]="scheduleData.note"
                                (outputText)="receiveFormalizedComment($event)"
                                [sourceScreen]="sourceScreen"
                                [candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
                                [company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
                                [requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
                                [jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null">
                            </app-formalize-comment>
                        </div>
                    </div>

                   <div class="col-xs-12" *ngIf="isSharedRequisition || isExternalRequisition">
                        <app-external-notes [form]="cancelForm"
                            [note]="scheduleData.note"
                            [externalNote]="scheduleData.externalNote"
                            [copyNote]="copyNote"
                            [sourceScreen]="sourceScreen"
                            [formalizeActivityPayload]="formalizeActivityPayload"
                            (onExternalNoteChange)="onExternalNoteChange($event)"
                            (onCopyNoteChange)="onCopyNoteChange($event)">
                        </app-external-notes>
                    </div>
                </div>
                <div class="row" *ngIf="showFormFlag">
                    <div class="col-xs-12 text-right">
                        <div class="clearfix">
                            <button type="submit" class="btn btn-success" (click)="cancelMeeting()" [disabled]="savingFlag || viewMode">
                                <span *ngIf="!savingFlag">{{cancelLabel}}</span>
                                <span *ngIf="savingFlag">Cancelling..</span>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>